import { ReviewPageFilters } from './reviewpagefilters';
import { ReviewPagePaging } from './reviewPagePaging';
import { ReviewPageReviews } from './ReviewPageReviews';
import { ReviewPageSort } from './ReviewPageSort';
document.addEventListener('DOMContentLoaded', () => {
    // Find and Setup each Review Container on a page with sorting, paging and filtering
    const reviewContainers = document.querySelectorAll('.review-container');
    reviewContainers.forEach((reviewContainer) => {
        ReviewPageSort.setupSort(reviewContainer);
        ReviewPageFilters.setupFilters(reviewContainer);
        ReviewPageReviews.setupReviewContainer(reviewContainer);
        ReviewPagePaging.setupPaging(reviewContainer, 10);
    });
    // Setup Dropdown groups to toggle active on click for Star Rating Dropdown
    document.querySelectorAll('.dropdown-group').forEach((dropdownGroup) => {
        dropdownGroup.addEventListener('click', () => {
            dropdownGroup.classList.toggle('active');
        });
    });
});
